import { environment } from '../../../environments/environment';
import { INTERNAL_API_BASE_URL } from '../api/mhsInternalApiTokens';

export function provideInternalApiBaseUrl() {
  return {
    provide: INTERNAL_API_BASE_URL,
    useValue: environment.internalApiUrl
  };
}